var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { metresToMiles, toggleHidden } from "../../helpers";
var latLngDataAttribute = 'branchLatLng';
var distanceDataAttribute = 'branchDistance';
var titleDataAttribute = 'branchTitle';
var white = 'rgba(255, 255, 255, 1)';
var blue = 'rgba(0, 67, 122, 1)';
var gold = 'rgba(251, 186, 0, 1)';
/**
 * Manages progressively enhancing branch finder lists
 */
var BranchFinderHandler = /** @class */ (function () {
    function BranchFinderHandler(props) {
        var _a;
        this.wrapper = undefined;
        this.locationFilter = undefined;
        this.geoLocationFilter = undefined;
        this.sortOrderFilter = undefined;
        this.map = undefined;
        this.list = undefined;
        this.autoComplete = undefined;
        this.googleMap = undefined;
        this.googleMapMarkers = [];
        this.googleMapDefaultZoom = undefined;
        this.minimumIncludedMapLocations = undefined;
        this.init = this.init.bind(this);
        this.initLocationFilter = this.initLocationFilter.bind(this);
        this.resetLocationFilter = this.resetLocationFilter.bind(this);
        this.initGeoLocationFilter = this.initGeoLocationFilter.bind(this);
        this.initSortOrderFilter = this.initSortOrderFilter.bind(this);
        this.csvToLatLng = this.csvToLatLng.bind(this);
        this.renderItems = this.renderItems.bind(this);
        this.renderMap = this.renderMap.bind(this);
        this.renderMapLocations = this.renderMapLocations.bind(this);
        this.destroyMap = this.destroyMap.bind(this);
        this.sortItemsByDistance = this.sortItemsByDistance.bind(this);
        this.wrapper = props.wrapper;
        this.locationFilter = props.locationFilter;
        this.geoLocationFilter = props.geoLocationFilter;
        this.sortOrderFilter = props.sortOrderFilter;
        this.map = props.map;
        this.list = props.list;
        this.googleMapDefaultZoom = props.googleMapDefaultZoom;
        this.minimumIncludedMapLocations = (_a = props.minimumIncludedMapLocations) !== null && _a !== void 0 ? _a : 2;
        this.init();
    }
    /**
     * Re-renders the location item list
     */
    BranchFinderHandler.prototype.renderItems = function (_a) {
        var _this = this;
        var items = _a.items, shouldRenderIndexing = _a.shouldRenderIndexing;
        this.list.innerHTML = '';
        items.forEach(function (item, index) {
            var indexElement = item.querySelector('[data-branch-index]');
            var distanceElement = item.querySelector('[data-branch-distance]');
            var icon = "<svg width=\"42\" height=\"42\" viewBox=\"0 0 42 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                <path d=\"M22 0c3.978 0 7.794 1.549 10.607 4.306C35.42 7.062 37 10.8 37 14.7 37 25.725 22 42 22 42S7 25.725 7 14.7c0-3.899 1.58-7.638 4.393-10.394C14.206 1.549 18.022 0 22 0z\" fill=\"#00437A\"/>\n                <text fill=\"#ffffff\" x=\"21\" y=\"21\" text-anchor=\"middle\" font-size=\"14px\">".concat(index + 1, "</text>\n            </svg>");
            if (indexElement) {
                toggleHidden(indexElement, !shouldRenderIndexing);
                indexElement.innerHTML = shouldRenderIndexing ? icon : '';
            }
            if (distanceElement) {
                if (shouldRenderIndexing) {
                    var distanceInMetres = Number(item.dataset[distanceDataAttribute]);
                    var distanceInMiles = metresToMiles(distanceInMetres);
                    if (!isNaN(distanceInMiles)) {
                        distanceElement.innerHTML = "(".concat(Math.trunc(distanceInMiles).toString(), " miles)");
                    }
                    else {
                        distanceElement.innerHTML = '';
                    }
                }
                else {
                    distanceElement.innerHTML = '';
                }
                toggleHidden(distanceElement, !shouldRenderIndexing);
            }
            _this.list.appendChild(item);
        });
    };
    /**
     * Renders the map wrapper and initialises the Google map
     */
    BranchFinderHandler.prototype.renderMap = function (_a) {
        var zoom = _a.zoom, center = _a.center;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                this.destroyMap();
                toggleHidden(this.map, false);
                this.googleMap = new google.maps.Map(this.map, {
                    zoom: zoom,
                    center: center,
                    mapTypeControl: false,
                    fullscreenControl: false,
                    mapId: 'branch-finder',
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Renders the markers for the user's searched location and the branches on the Google map
     */
    BranchFinderHandler.prototype.renderMapLocations = function (_a) {
        var _b, _c;
        var searchLocation = _a.searchLocation;
        return __awaiter(this, void 0, void 0, function () {
            var _d, AdvancedMarkerElement, PinElement, branchLocations, items, bounds, pinBackground, i, closestLatLng;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, google.maps.importLibrary("marker")];
                    case 1:
                        _d = _e.sent(), AdvancedMarkerElement = _d.AdvancedMarkerElement, PinElement = _d.PinElement;
                        branchLocations = [];
                        items = Array.from((_c = (_b = this.list) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : []);
                        items.forEach(function (item) {
                            var title = item.dataset[titleDataAttribute];
                            var latLng = _this.csvToLatLng(item.dataset[latLngDataAttribute]);
                            if (latLng !== null) {
                                var distance = window.google.maps.geometry.spherical.computeDistanceBetween(searchLocation, latLng);
                                item.dataset[distanceDataAttribute] = Math.trunc(distance).toString();
                                branchLocations.push({
                                    title: title,
                                    latLng: latLng,
                                    distance: distance
                                });
                            }
                        });
                        branchLocations.sort(function (a, b) { return a.distance - b.distance; });
                        this.renderMap({
                            zoom: this.googleMapDefaultZoom,
                            center: searchLocation
                        });
                        this.sortOrderFilter.querySelector('select').value = '3';
                        bounds = new window.google.maps.LatLngBounds();
                        pinBackground = new PinElement({
                            glyphColor: blue,
                            borderColor: blue,
                            background: gold,
                        });
                        this.googleMapMarkers.push(new AdvancedMarkerElement({
                            position: searchLocation,
                            map: this.googleMap,
                            title: "We think you're here",
                            content: pinBackground.element
                        }));
                        branchLocations.forEach(function (branchLocation, index) {
                            var pinBackground = new PinElement({
                                glyph: (index + 1).toString(),
                                glyphColor: white,
                                borderColor: blue,
                                background: blue,
                            });
                            _this.googleMapMarkers.push(new AdvancedMarkerElement({
                                position: branchLocation.latLng,
                                map: _this.googleMap,
                                title: branchLocation.title,
                                content: pinBackground.element
                            }));
                        });
                        bounds.extend(searchLocation);
                        for (i = 0; i < branchLocations.length; i++) {
                            if (i < this.minimumIncludedMapLocations) {
                                closestLatLng = branchLocations[i].latLng;
                                bounds.extend(closestLatLng);
                            }
                        }
                        this.googleMap.fitBounds(bounds);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Converts a valid CSV to a Google maps LatLng object
     */
    BranchFinderHandler.prototype.csvToLatLng = function (csv) {
        var csvParts = csv.split(',');
        if (csvParts.length <= 1) {
            console.debug("csv ".concat(csv, " is not in valid coords format"));
            return null;
        }
        var lat = Number(csvParts[0]);
        var lng = Number(csvParts[1]);
        if (isNaN(lat) || isNaN(lng)) {
            console.debug("csv ".concat(csv, " is not valid latLng"));
            return null;
        }
        var latLng = new window.google.maps.LatLng({
            lat: lat,
            lng: lng
        });
        return latLng;
    };
    /**
     * Hides the map wrapper and tears down the Google map instance
     */
    BranchFinderHandler.prototype.destroyMap = function () {
        this.map.setAttribute('hidden', 'hidden');
        this.googleMapMarkers.forEach(function (marker) {
            marker.setMap(null);
            marker = null;
        });
        this.googleMapMarkers = [];
        this.googleMap = null;
    };
    /**
     * Sorts the location item list by proximity to the user's seatrched location, ordered by closest first
     */
    BranchFinderHandler.prototype.sortItemsByDistance = function () {
        var _a, _b;
        var items = Array.from((_b = (_a = this.list) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
        var sortedItems = items.sort(function (a, b) {
            var aDistance = Number(a.dataset[distanceDataAttribute]);
            var bDistance = Number(b.dataset[distanceDataAttribute]);
            return aDistance - bDistance;
        });
        this.renderItems({ items: sortedItems, shouldRenderIndexing: true });
    };
    /**
        * Initialises the location search filter
        */
    BranchFinderHandler.prototype.initLocationFilter = function () {
        var _this = this;
        var input = this.locationFilter.querySelector('input');
        var bounds = new window.google.maps.LatLngBounds();
        bounds.extend(new window.google.maps.LatLng(49.64828404100335, -10.963513944150023));
        bounds.extend(new window.google.maps.LatLng(59.340361664775195, -0.04310367356441767));
        this.autoComplete = new window.google.maps.places.Autocomplete(input, {
            bounds: bounds,
            strictBounds: false,
        });
        this.autoComplete.setFields(["place_id", "geometry", "name"]);
        this.autoComplete.addListener("place_changed", function () { return __awaiter(_this, void 0, void 0, function () {
            var place, searchLocation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        place = this.autoComplete.getPlace();
                        if (!(place && place.geometry)) return [3 /*break*/, 2];
                        searchLocation = place.geometry.location;
                        return [4 /*yield*/, this.renderMapLocations({ searchLocation: searchLocation })];
                    case 1:
                        _a.sent();
                        this.sortItemsByDistance();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        /**
         * Jump through an absurd number of hoops to support the user hitting enter in the Google Maps Autocomplete
         * because it's 2023 now but the control still doesn't support it
         */
        this.locationFilter.addEventListener('submit', function (event) {
            event.preventDefault();
            var service = new window.google.maps.places.AutocompleteService();
            var input = _this.autoComplete.getPlace().name;
            service.getPlacePredictions({
                input: input,
                locationBias: bounds
            }, function (predictions, status) {
                if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions.length > 0) {
                    var place = predictions[0];
                    var placeId = place['place_id'];
                    var geoCoder = new google.maps.Geocoder();
                    geoCoder
                        .geocode({ placeId: placeId })
                        .then(function (_a) {
                        var results = _a.results;
                        return __awaiter(_this, void 0, void 0, function () {
                            var result, searchLocation;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!(results.length > 0)) return [3 /*break*/, 2];
                                        result = results[0];
                                        searchLocation = result.geometry.location;
                                        return [4 /*yield*/, this.renderMapLocations({ searchLocation: searchLocation })];
                                    case 1:
                                        _b.sent();
                                        this.sortItemsByDistance();
                                        _b.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        });
                    })
                        .catch(function (e) { return console.debug("Geocoder failed due to: " + e); });
                }
            });
        });
    };
    /**
     * Resets the location search filter to initial state
     */
    BranchFinderHandler.prototype.resetLocationFilter = function () {
        var input = this.locationFilter.querySelector('input');
        input.value = '';
    };
    /**
     * Initialises the geolocation search filter
     */
    BranchFinderHandler.prototype.initGeoLocationFilter = function () {
        var _this = this;
        this.geoLocationFilter.addEventListener('click', function () {
            window.navigator.geolocation.getCurrentPosition(function (position) { return __awaiter(_this, void 0, void 0, function () {
                var coords, searchLocation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            coords = position.coords;
                            searchLocation = new window.google.maps.LatLng({
                                lat: coords.latitude,
                                lng: coords.longitude
                            });
                            return [4 /*yield*/, this.renderMapLocations({ searchLocation: searchLocation })];
                        case 1:
                            _a.sent();
                            this.resetLocationFilter();
                            this.sortItemsByDistance();
                            return [2 /*return*/];
                    }
                });
            }); }, function () {
                // TODO - if anything
            });
        });
    };
    /**
     * Initialises the location search results sorter
     */
    BranchFinderHandler.prototype.initSortOrderFilter = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var select, items, handlers;
            var _c;
            var _this = this;
            return __generator(this, function (_d) {
                select = this.sortOrderFilter.querySelector('select');
                items = Array.from((_b = (_a = this.list) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
                handlers = (_c = {},
                    _c['1'] = function () {
                        var sortedItems = items.sort(function (a, b) { return a.dataset[titleDataAttribute].localeCompare(b.dataset[titleDataAttribute]); });
                        _this.renderItems({ items: sortedItems });
                    },
                    _c['2'] = function () {
                        var sortedItems = items.sort(function (a, b) { return b.dataset[titleDataAttribute].localeCompare(a.dataset[titleDataAttribute]); });
                        _this.renderItems({ items: sortedItems });
                    },
                    _c);
                select.addEventListener('change', function (event) {
                    var _a;
                    var value = select.value;
                    (_a = handlers[value]) === null || _a === void 0 ? void 0 : _a.call(handlers);
                    _this.resetLocationFilter();
                    _this.destroyMap();
                });
                return [2 /*return*/];
            });
        });
    };
    /**
     * Initialises the module
     */
    BranchFinderHandler.prototype.init = function () {
        this.initLocationFilter();
        this.initSortOrderFilter();
        this.initGeoLocationFilter();
    };
    return BranchFinderHandler;
}());
export { BranchFinderHandler };
export default BranchFinderHandler;
